import Navbar from "./Navbar";
import OurTeam from "./Team/Our_Team";
import FacultyData from "./Team/Our_Faculty";
import Footer from "./Footer";
import './Css/Team.css';

function Team() {
    return (
      <div>
        <Navbar />
        <OurTeam />
        <FacultyData />
        <Footer />
      </div>
    );
  }
  
export default Team;